export default "__VITE_ASSET__Xqtw$h4c__"